module.exports = __webpack_public_path__ + "img/product-placeholder-25.335a81c.png";